<table style="width:100%">
  <tr>
    <th>{{ 'system-log.column.value-name' | translate }}</th>
    <th>{{ 'system-log.column.previous-value' | translate }}</th>
    <th>{{ 'system-log.column.current-value' | translate }}</th>
  </tr>
  @for (key of getLoggedEntityValueKeys(); track key) {
    <tr [hidden]="hideUnchanged && !isDifferent(key)" [ngClass]=" {'highlight' : isDifferent(key) && !hideUnchanged }">
      <td>{{ key }}</td>
      <td>{{ previousEntity ? displayValue(previousEntity[key]) : '' }}</td>
      <td>{{ currentEntity ? displayValue(currentEntity[key]) : '' }}</td>
    </tr>
  }
</table>